import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

import { BlockBDCNavy, BlockBDCWhiteBgBlueText } from '@jelly/components'

const HeaderInfo = styled.header`
	background-color: ${({ theme }) => theme.colors.white};
	height: auto;
	width: 100%;
	z-index: -1;

	${({ theme }) => theme.MQ.M} {
		&.lazyloaded {
			background: linear-gradient(0deg, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.72)),
				url(${({ backgroundSrc }) => backgroundSrc});
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
			box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
		}
	}
`
const InfoContext = styled.div`
	margin: 0 auto;
	padding: 2rem 0;
	width: 90%;

	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.maxWidth.L};
		margin: 0 auto 3rem;
		padding: 2rem 0 4rem;
	}
`
const LogoContainer = styled.div`
	height: auto;
	width: 188px;
`
const Title = styled.h1`
	${({ theme }) => theme.fonts.bold};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 36px;
	letter-spacing: 0;
	line-height: 42px;
	margin: 0.5rem auto;

	${({ theme }) => theme.MQ.M} {
		font-size: 44px;
		line-height: 60px;
	}

	${({ theme }) => theme.MQ.XL} {
		font-size: 54px;
		line-height: 80px;
	}
`
const Subtitle = styled.div`
	display: none;

	${({ theme }) => theme.MQ.M} {
		color: ${({ theme }) => theme.colors.tertiary};
		display: block;
		${({ theme }) => theme.fonts.primary};
		font-size: 22px;
		letter-spacing: 0;
		line-height: 28px;
	}

	${({ theme }) => theme.MQ.XL} {
		font-size: 28px;
		line-height: 32px;
	}
`
const StyledBlueLogo = styled.div`
	display: block;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`
const StyledWhiteLogo = styled.div`
	display: none;

	width: 100%;

	${({ theme }) => theme.MQ.M} {
		display: block;
		svg {
			// align the logo with the text
			margin-left: -10px;
		}
	}
`

HeaderInfo.propTypes = {
	backgroundImage: string,
	subtitle: string,
	title: string,
}

/**
 * Header for Top Five QT Landing Page Template
 * Consists of hero background image, subtitle, and title
 *
 * @param {String} props.backgroundImage :: url of background image
 * @param {Object} props.subtitle :: data for subtitle
 * @param {String} props.title :: data for title
 */
export function Header({ backgroundImage, subtitle, title }) {
	return (
		<HeaderInfo className="lazyload" backgroundSrc={backgroundImage}>
			<InfoContext>
				<LogoContainer>
					{/* Only showed on screens < 768px */}
					<StyledBlueLogo>
						<BlockBDCNavy />
					</StyledBlueLogo>
					{/* Only showed on screens >= 768px */}
					<StyledWhiteLogo>
						<BlockBDCWhiteBgBlueText />
					</StyledWhiteLogo>
				</LogoContainer>
				<Title>{title}</Title>
				<Subtitle>{subtitle && subtitle}</Subtitle>
			</InfoContext>
		</HeaderInfo>
	)
}
